module.exports = __webpack_public_path__ + "static/media/footerlogo.648d0787.png";